import { ComponentProps, FC } from 'react';
import Modal from '@/components/modals/Modal/Modal.tsx';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-daisyui';
import { useAuthContext } from '@/context/AuthContext.tsx';
import SearchParams from '@/_constants/SearchParams.ts';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';

const SubscriberUpgradeModal: FC<Pick<ComponentProps<typeof Modal.Wrapper>, 'isOpen' | 'onClose'>> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();

  const handleGoToPaymentPage = () => {
    const redirectUrl = new URL(window.location.href);

    window.location.href = passToRouteSearchParams(`${import.meta.env.VITE_FRONTEND_URL}/payment-select`, {
      [SearchParams.REDIRECT_URL]: encodeURIComponent(redirectUrl.toString()),
      [SearchParams.CURRENT_PLAN]: user?.plan_tier ?? '',
    });
  };

  return (
    <Modal.Wrapper isOpen={isOpen} onClose={onClose} closeable className="flex flex-col pb-2 gap-4 w-[400px]">
      <Modal.Title>
        <h1 className="text-2xl font-bold">{t('modal.subscriberUpgrade.title')}</h1>
      </Modal.Title>
      <p className="text-text-secondary text-sm">{t('modal.subscriberUpgrade.description')}</p>
      <Modal.Nav>
        {({ handleClose }) => (
          <div className="flex justify-between gap-4 grow">
            <Button type="button" variant="outline" color="primary" onClick={handleClose}>
              {t('button.skip')}
            </Button>
            <Button type="button" color="primary" onClick={handleGoToPaymentPage}>
              {t('button.upgrade')}
            </Button>
          </div>
        )}
      </Modal.Nav>
    </Modal.Wrapper>
  );
};

export default SubscriberUpgradeModal;
